import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const EmissieklasseFilter = ({ condensed }) => {
    const filterOptions = useFilter("emissiecode");
    const [emissieklasseValue, , onEmissieklasseChange] = useField("emissiecode");

    const emissieklasseOptions =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option}`,
            naam: `${option}`
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-emissiecode"
                options={emissieklasseOptions}
                value={emissieklasseValue || []}
                handleChange={(_, value) => onEmissieklasseChange(value)}
                datalayerKey="emissiecode"
                columns={condensed ? 2 : emissieklasseOptions.length}
            />
            <Empty />
        </Grid>
    );
};
